import { fontSize, fontWeight, shorthandHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  container: css({
    padding: shorthandHelper([spacing.extraLarge, 0]),
  }),

  image: css({
    display: 'block',
    margin: shorthandHelper([0, 'auto', spacing.large]),
  }),

  title: css({
    textAlign: 'center',
    margin: 0,
    fontWeight: fontWeight.bold,
    fontSize: fontSize.extraLarge,
  }),

  heading: dataLevel => {
    let marginTop = 0
    let marginBottom = spacing.large
    switch (dataLevel) {
    case '0':
      marginTop = spacing.extraLarge
      break
    case '1':
      marginTop = spacing.large
      marginBottom = spacing.medium
      break
    case '2':
      marginTop = spacing.default
      break
    default:
      break
    }

    return css({
      fontWeight: fontWeight.semiBold,
      fontSize: fontSize.large,
      marginTop,
      marginBottom,
    })
  },

  effectiveDate: css({
    fontWeight: fontWeight.semiBold,
  }),

  notification: css({
    p: {
      margin: 0,
      padding: 0,
    },

    'p:not(:last-child)': {
      padding: 0,
      margin: shorthandHelper([0, 0, spacing.default]),
    },

    'p:last-child': {
      paddingBottom: 0,
      marginBottom: 0,
    },
  }),

  strongText: css({
    fontWeight: fontWeight.medium,
  }),

  termsDefinitions: css({
    marginTop: spacing.large,
    div: {
      marginBottom: spacing.large,
    },

    dt: {
      display: 'inline',
    },

    dd: {
      display: 'inline',
      margin: 0,
    },
  }),
}

export default styles
